import React from 'react';
import { Box } from '@mui/material';

import withOptionsWidget, { WithOptionsWidgetProps } from 'components/widgetParts/withOptionsWidget'
import ColorBoxSettings, { defaultSettings } from './ColorBoxSettings';

function ColorBox(props: WithOptionsWidgetProps) {
  // Old settings were stored in the "data" object.
  // Using both widget.data & widget.data.settings provides backwards compatibility
  const currentState = {
    ...defaultSettings,
    ...props.widget?.data,
    ...props.widget?.data?.settings
  };

  return (
    <Box sx={{ height: "100%", backgroundColor: currentState.colorValue }}>
      {props.settingsDialogIsOpen && <ColorBoxSettings {...props} />}
    </Box>
  )
}

export default withOptionsWidget(ColorBox, {hasSettingsDialog: true});